import React from "react";
import { useTranslation } from "react-i18next";
import { FilterItemTypes } from "configs/types";
import Filter from "components/global/Filter/Filter";
import gridIcon from "assets/icons/grid-icon.svg";

interface Props {
  searchValue: string;
  handleSearch: (e: string) => void;

  searchId: string;
  handleSearchId: (e: string) => void;

  handleUpdateRisks: (e: { value: string | number; label: string }[]) => void;
  selectedRisks: { value: string | number; label: string }[];

  handleUpdateStatuses: (
    e: { value: string | number; label: string }[],
  ) => void;
  selectedStatuses: { value: string | number; label: string }[];

  handleApply: () => void;
}

const PlayersRiskFilter: React.FC<Props> = ({
  searchValue,
  handleSearch,

  searchId,
  handleSearchId,

  handleUpdateRisks,
  selectedRisks,

  handleUpdateStatuses,
  selectedStatuses,

  handleApply,
}) => {
  const { t } = useTranslation();
  const risks = [
    { value: "none", label: "none" },
    { value: "low", label: "low" },
    { value: "medium", label: "medium" },
    { value: "high", label: "high" },
  ];

  const statuses = [
    { value: "none", label: "none" },
    { value: "pending", label: "pending" },
    { value: "approved", label: "approved" },
    { value: "rejected", label: "rejected" },
  ];



  const handleApplyRisks = (
    e: { value: string | number; label: string }[],
    isDelete?: boolean,
  ) => {
    handleUpdateRisks(isDelete ? e : [...selectedRisks, ...e]);
  };

  const handleApplyStatuses = (
    e: { value: string | number; label: string }[],
    isDelete?: boolean,
  ) => {
    handleUpdateStatuses(isDelete ? e : [...selectedStatuses, ...e]);
  };

  const handleClearFilters = () => {
    handleUpdateRisks([]);
    handleSearchId("");
    handleUpdateStatuses([]);
    handleSearch("");
    handleApply();
  };

  return (
    <Filter
      handleClear={handleClearFilters}
      handleApply={handleApply}
      filterItems={[
        {
          type: FilterItemTypes.input,
          title: t("userEmail"),
          boxTitle: t("userEmail"),
          icon: gridIcon,
          inputValue: searchValue,
          setInputValue: handleSearch,
          inputType: "text",
        },
        {
          type: FilterItemTypes.input,
          title: t("userId"),
          boxTitle: t("userId"),
          icon: gridIcon,
          inputValue: searchId,
          setInputValue: handleSearchId,
          inputType: "number",
        },
        {
          type: FilterItemTypes.multiselect,
          title: t("riskLevel"),
          boxTitle: t("riskLevel"),
          icon: gridIcon,
          itemsArray: risks,
          activeItems: selectedRisks,
          handleApply: handleApplyRisks,
        },
        {
          type: FilterItemTypes.multiselect,
          title: t("kycStatus"),
          boxTitle: t("kycStatus"),
          icon: gridIcon,
          itemsArray: statuses,
          activeItems: selectedStatuses,
          handleApply: handleApplyStatuses,
        },
      ]}
    />
  );
};

export default PlayersRiskFilter;
